import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { PositionFetchAPI } from '../../api/Position';
import { GroupsFechtAPI } from '../../api/Groups'
import { Button, Modal, Row, Col } from 'react-bootstrap';
import stand from '../../assets/img/vending/stand.png'
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import { MachinesFetchAPI } from '../../api/Machines';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import { RenderIf } from '../../components/utils/RenderIf';
import { VendingFetchAPI } from '../../api/LocalRequest/Vending'
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import empty from '../../assets/img/vending/empty.png'
import Swal from 'sweetalert2';
import { buildCloudinaryImageUrl } from '../utils/CloudinaryImageUrl';
import defaultImage from "../../assets/img/default.png"

import 'react-simple-keyboard/build/css/index.css';

/* ═════════════════════════════════════════════════════════════
   CSS puro — sin react-bootstrap <Modal>. Prefijo .vm-*
   Modal como overlay + panel montados por portal a document.body.
   Header fijo minimalista (blanco + hairline), body scrolleable,
   grid auto-fill con celdas legibles.
═════════════════════════════════════════════════════════════ */
const VM_CSS = `
@keyframes vm-fade  { from{opacity:0} to{opacity:1} }
@keyframes vm-pop   { from{opacity:0;transform:translateY(8px) scale(.98)} to{opacity:1;transform:none} }
@keyframes vm-sheet { from{transform:translateY(100%)} to{transform:none} }
@keyframes vm-in    { from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:none} }

/* ══════ TOKENS ══════ */
.vm-root, .vm-trigger {
  --vm-font: var(--font-sans, 'Geist', -apple-system, 'Segoe UI', Roboto, sans-serif);
  --vm-line: #E3E7EE;
  --vm-line-strong: #CBD2DE;
  --vm-cell: #F8FAFC;
  --vm-bg:   #F3F5F9;
  --vm-text: #0F172A;
  --vm-text-2: #475467;
  --vm-muted: #8A94A6;
  --vm-brand: var(--brand, #1B3A6B);
  --vm-brand-hover: var(--brand-hover, #152D54);
  --vm-brand-dim: rgba(27,58,107,.09);
  --vm-accent: var(--accent, #2563EB);
  --vm-accent-hover: #1D4ED8;
  --vm-accent-dim: rgba(37,99,235,.09);
  --vm-accent-ring: rgba(37,99,235,.22);
  --vm-green: #0EA35B;
  --vm-green-dim: rgba(14,163,91,.11);
  --vm-amber-ink: #B45309;
  --vm-amber-dim: rgba(245,158,11,.14);
  --vm-red: #E11D2E;
  --vm-red-dim: rgba(225,29,46,.09);
  --vm-radius: 14px;
  font-family: var(--vm-font);
}

/* ══════ TRIGGER ══════ */
.vm-trigger {
  display: inline-flex; align-items: center; justify-content: center;
  width: 38px; height: 38px; border-radius: 10px;
  border: 1px solid var(--vm-line);
  background: #fff; color: var(--vm-accent);
  cursor: pointer;
  transition: background .15s ease, border-color .15s ease, color .15s ease, box-shadow .15s ease;
}
.vm-trigger:hover { background: var(--vm-accent); border-color: var(--vm-accent); color: #fff; box-shadow: 0 6px 16px rgba(37,99,235,.22); }
.vm-trigger:active { transform: scale(.96); }
.vm-trigger:focus-visible { outline: none; box-shadow: 0 0 0 3px var(--vm-accent-ring); }

/* ══════ OVERLAY + PANEL ══════ */
.vm-overlay {
  position: fixed; inset: 0;
  display: flex; align-items: center; justify-content: center;
  padding: 0;
  background: rgba(15,23,42,.55);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  z-index: 1080;
  animation: vm-fade .18s ease both;
}
.vm-panel {
  position: relative;
  display: flex; flex-direction: column;
  width: 100vw;
  height: 100vh; height: 100dvh;
  background: #fff;
  border-radius: 0;
  overflow: hidden;
  color: var(--vm-text);
  animation: vm-pop .22s cubic-bezier(.2,.8,.3,1) both;
}
.vm-panel--sm { /* modal 2 (detalle) */ }
@media (min-width: 900px) {
  .vm-overlay { padding: 1.5rem; }
  .vm-panel {
    width: min(1180px, 100%);
    height: min(calc(100vh - 3rem), 900px);
    height: min(calc(100dvh - 3rem), 900px);
    border-radius: 18px;
    box-shadow: 0 24px 60px rgba(15,23,42,.24);
  }
  .vm-panel--sm { width: min(560px, 100%); height: auto; max-height: min(calc(100dvh - 3rem), 900px); }
}
@media (max-width: 899px) {
  .vm-overlay { align-items: flex-end; }
  .vm-panel { animation: vm-sheet .28s cubic-bezier(.2,.8,.3,1) both; }
}

/* ══════ HEAD (fijo, minimalista) ══════ */
.vm-head {
  display: flex; align-items: center; gap: .6rem;
  flex-shrink: 0;
  padding: .8rem 1rem;
  padding-top: max(.8rem, env(safe-area-inset-top));
  background: #fff;
  border-bottom: 1px solid var(--vm-line);
  min-height: 60px;
  z-index: 2;
}
.vm-head-back, .vm-head-close {
  display: grid; place-items: center;
  width: 40px; height: 40px; flex-shrink: 0;
  border: 1px solid var(--vm-line);
  border-radius: 10px;
  background: #fff;
  color: var(--vm-text-2);
  cursor: pointer;
  transition: background .14s ease, border-color .14s ease, color .14s ease;
}
.vm-head-back:hover { background: var(--vm-cell); border-color: var(--vm-line-strong); color: var(--vm-text); }
.vm-head-back:focus-visible, .vm-head-close:focus-visible { outline: none; box-shadow: 0 0 0 3px var(--vm-accent-ring); }
.vm-head-close:hover { background: var(--vm-red-dim); border-color: rgba(225,29,46,.28); color: var(--vm-red); }
.vm-head-close:focus-visible { box-shadow: 0 0 0 3px rgba(225,29,46,.22); }
.vm-head-title { flex: 1; min-width: 0; display: flex; align-items: baseline; gap: .5rem; }
.vm-head-h {
  margin: 0;
  font-size: 1rem; font-weight: 700; letter-spacing: -.01em;
  color: var(--vm-text);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.vm-head-sub { font-size: .78rem; font-weight: 500; color: var(--vm-muted); }
.vm-head-count {
  display: inline-grid; place-items: center;
  min-width: 24px; height: 20px; padding: 0 .45rem;
  border-radius: 999px;
  background: var(--vm-cell); color: var(--vm-text-2);
  font-size: .68rem; font-weight: 700; line-height: 1;
  font-variant-numeric: tabular-nums;
}

/* ══════ BODY scrolleable ══════ */
.vm-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
  padding-bottom: max(1rem, env(safe-area-inset-bottom));
  background: var(--vm-bg);
  scrollbar-width: thin;
  scrollbar-color: var(--vm-line-strong) transparent;
}
.vm-body::-webkit-scrollbar { width: 6px; }
.vm-body::-webkit-scrollbar-thumb { background: var(--vm-line-strong); border-radius: 4px; }
.vm-body--plain { background: #fff; }

/* ══════ HEAD variantes ══════ */
.vm-head--assign { flex-direction: column; align-items: stretch; gap: .55rem; padding-bottom: .85rem; }
.vm-head-row { display: flex; align-items: center; gap: .5rem; }
.vm-search {
  display: flex; align-items: center; gap: .55rem;
  height: 44px; padding: 0 .8rem;
  border-radius: 12px;
  background: var(--vm-cell);
  border: 1px solid var(--vm-line);
  transition: border-color .15s ease, box-shadow .15s ease;
}
.vm-search:focus-within { border-color: var(--vm-accent); box-shadow: 0 0 0 3px var(--vm-accent-ring); background: #fff; }
.vm-search-ico { color: var(--vm-muted); flex-shrink: 0; }
.vm-search:focus-within .vm-search-ico { color: var(--vm-accent); }
.vm-search-input {
  flex: 1; min-width: 0; height: 100%;
  border: 0; outline: 0; background: transparent;
  color: var(--vm-text); font: inherit; font-size: .92rem; font-weight: 500;
}
.vm-search-input::placeholder { color: var(--vm-muted); font-weight: 500; }

/* ══════ LEGEND ══════ */
.vm-legend { display: flex; flex-wrap: wrap; gap: .4rem; margin: 0 0 .85rem; }
.vm-legend-item {
  display: inline-flex; align-items: center; gap: .35rem;
  padding: .3rem .6rem; border-radius: 999px;
  background: #fff; border: 1px solid var(--vm-line);
  font-size: .72rem; font-weight: 600; color: var(--vm-text-2);
}
.vm-legend-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.vm-legend-dot.is-ok       { background: var(--vm-green); }
.vm-legend-dot.is-low      { background: #F59E0B; }
.vm-legend-dot.is-out      { background: var(--vm-red); }
.vm-legend-dot.is-empty    { background: var(--vm-line-strong); }
.vm-legend-dot.is-disabled { background: #334155; }

/* ══════ GRID de posiciones ══════ */
.vm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: .75rem;
}
@media (max-width: 480px) {
  .vm-grid { grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: .55rem; }
}

/* ══════ CELDA / SLOT ══════ */
.vm-slot {
  --slot-ink: var(--vm-muted);
  --slot-tint: var(--vm-cell);
  position: relative;
  display: flex; flex-direction: column;
  gap: .55rem;
  min-height: 148px;
  padding: .75rem .85rem .8rem 1rem;
  border-radius: 14px;
  background: #fff;
  border: 1px solid var(--vm-line);
  box-shadow: 0 1px 2px rgba(15,23,42,.04);
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  animation: vm-in .2s ease both;
  transition: border-color .14s ease, box-shadow .14s ease, transform .14s ease;
  font-family: inherit; color: inherit;
}
button.vm-slot { width: 100%; }
.vm-slot::before {
  content: '';
  position: absolute; top: 0; left: 0; bottom: 0;
  width: 3px;
  background: var(--slot-ink);
  border-radius: 3px 0 0 3px;
}
.vm-slot:hover {
  transform: translateY(-1px);
  border-color: var(--slot-ink);
  box-shadow: inset 0 0 0 1px var(--slot-ink), 0 8px 20px rgba(15,23,42,.08);
}
.vm-slot:active { transform: scale(.99); }
.vm-slot-head { display: flex; align-items: center; gap: .5rem; }
.vm-slot-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; background: var(--slot-ink); }
.vm-slot-coord {
  font-size: .72rem; font-weight: 700; letter-spacing: .04em;
  color: var(--vm-text-2); font-variant-numeric: tabular-nums;
}
.vm-slot-chip {
  margin-left: auto;
  display: inline-flex; align-items: center;
  height: 20px; padding: 0 .5rem;
  border-radius: 999px;
  background: var(--slot-tint);
  color: var(--slot-ink);
  font-size: .64rem; font-weight: 700; letter-spacing: .04em;
  text-transform: uppercase; white-space: nowrap;
}
.vm-slot-name {
  font-size: .88rem; font-weight: 600; color: var(--vm-text);
  line-height: 1.3;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden; word-break: break-word;
}
.vm-slot-foot { margin-top: auto; display: flex; align-items: baseline; gap: .3rem; }
.vm-slot-amount {
  font-size: 1.65rem; font-weight: 800; letter-spacing: -.03em;
  color: var(--slot-ink); font-variant-numeric: tabular-nums; line-height: 1;
}
.vm-slot-unit {
  font-size: .68rem; font-weight: 600; color: var(--vm-muted);
  letter-spacing: .05em; text-transform: uppercase;
}
.vm-slot.is-ok  { --slot-ink: var(--vm-green);     --slot-tint: var(--vm-green-dim); }
.vm-slot.is-low { --slot-ink: var(--vm-amber-ink); --slot-tint: var(--vm-amber-dim); }
.vm-slot.is-out { --slot-ink: var(--vm-red);       --slot-tint: var(--vm-red-dim); }

/* vacío */
.vm-slot.is-empty {
  border: 1.5px dashed var(--vm-line-strong);
  background: #FBFCFD;
  padding: .75rem;
  justify-content: center; align-items: center;
  gap: .5rem;
}
.vm-slot.is-empty::before { display: none; }
.vm-slot.is-empty:hover {
  background: var(--vm-accent-dim);
  border-color: var(--vm-accent);
  border-style: solid;
}
.vm-slot.is-empty:hover .vm-slot-plus { background: var(--vm-accent); color: #fff; transform: rotate(90deg); }
.vm-slot.is-empty:hover .vm-slot-coord-abs { background: #fff; color: var(--vm-accent); }
.vm-slot-coord-abs {
  position: absolute; top: .55rem; left: .65rem;
  display: inline-flex; align-items: center; height: 20px; padding: 0 .45rem;
  border-radius: 6px; background: var(--vm-cell); color: var(--vm-text-2);
  font-size: .68rem; font-weight: 700; letter-spacing: .03em;
  font-variant-numeric: tabular-nums;
  transition: background .18s ease, color .18s ease;
}
.vm-slot-plus {
  display: grid; place-items: center;
  width: 44px; height: 44px; border-radius: 12px;
  background: var(--vm-cell); color: var(--vm-muted);
  font-size: 1.55rem; font-weight: 300; line-height: 1;
  transition: background .18s ease, color .18s ease, transform .3s cubic-bezier(.34,1.5,.6,1);
}
.vm-slot-empty-lbl { font-size: .74rem; font-weight: 600; color: var(--vm-muted); text-align: center; letter-spacing: .02em; }

/* inhabilitado */
.vm-slot.is-disabled {
  background: linear-gradient(180deg, #131E36, #1B2743);
  border-color: #2A3550;
  cursor: not-allowed;
  justify-content: center; align-items: center; gap: .45rem;
}
.vm-slot.is-disabled::before { background: rgba(255,255,255,.14); }
.vm-slot.is-disabled .vm-slot-coord-abs { background: rgba(255,255,255,.08); color: rgba(255,255,255,.7); }
.vm-slot-disabled-ico {
  display: grid; place-items: center;
  width: 44px; height: 44px; border-radius: 12px;
  background: rgba(255,255,255,.06); color: rgba(255,255,255,.5);
}
.vm-slot-disabled-lbl { font-size: .74rem; font-weight: 600; color: rgba(255,255,255,.68); letter-spacing: .02em; }
.vm-slot.is-disabled:hover { transform: none; box-shadow: 0 1px 2px rgba(0,0,0,.2); border-color: #2A3550; }

/* empty listado */
.vm-empty {
  display: flex; flex-direction: column; align-items: center; gap: .55rem;
  padding: 3rem 1rem;
  color: var(--vm-muted); text-align: center;
}
.vm-empty svg { color: var(--vm-line-strong); }
.vm-empty p { margin: 0; font-size: .9rem; }

/* ══════ MODAL 2 — DETALLE ══════ */
.vm-detail {
  flex: 1 1 auto;
  display: flex; flex-direction: column; gap: .85rem;
  padding: 1rem;
  padding-bottom: max(1rem, env(safe-area-inset-bottom));
  overflow-y: auto; min-height: 0;
  background: var(--vm-bg);
}
.vm-detail-card {
  display: flex; flex-direction: column; align-items: center; gap: .8rem;
  padding: 1rem;
  background: #fff; border: 1px solid var(--vm-line); border-radius: 16px;
  animation: vm-pop .3s ease both;
}
.vm-detail-coord {
  display: inline-flex; align-items: center; gap: .35rem;
  padding: .3rem .6rem; border-radius: 999px;
  background: var(--vm-brand-dim); color: var(--vm-brand);
  font-size: .72rem; font-weight: 700; letter-spacing: .05em;
}
.vm-detail-img {
  width: min(220px, 55vw); aspect-ratio: 1;
  display: grid; place-items: center;
  border-radius: 16px;
  background: var(--vm-cell); border: 1px solid var(--vm-line);
  overflow: hidden;
}
.vm-detail-img img { width: 100%; height: 100%; object-fit: cover; }
.vm-detail-title {
  margin: 0; text-align: center;
  font-size: 1.1rem; font-weight: 700; letter-spacing: -.01em; color: var(--vm-text);
}
.vm-counter {
  display: flex; flex-direction: column; gap: .65rem;
  padding: .95rem;
  background: #fff; border: 1px solid var(--vm-line); border-radius: 16px;
}
.vm-counter-label {
  font-size: .7rem; font-weight: 700; letter-spacing: .06em;
  text-transform: uppercase; color: var(--vm-muted); text-align: center;
}
.vm-counter-row { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.vm-counter-btn {
  display: grid; place-items: center;
  width: 64px; height: 64px; flex-shrink: 0;
  border: 0; border-radius: 18px;
  background: var(--vm-accent); color: #fff;
  font-size: 1.75rem; font-weight: 700; line-height: 1;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(37,99,235,.28);
  transition: background .15s ease, transform .1s ease, box-shadow .15s ease;
}
.vm-counter-btn:hover { background: var(--vm-accent-hover); box-shadow: 0 8px 22px rgba(37,99,235,.34); }
.vm-counter-btn:active { transform: scale(.92); }
.vm-counter-btn.is-minus { background: #fff; color: var(--vm-accent); border: 1.5px solid var(--vm-accent); box-shadow: 0 2px 8px rgba(37,99,235,.15); }
.vm-counter-btn.is-minus:hover { background: var(--vm-accent-dim); }
.vm-counter-num {
  flex: 1; text-align: center;
  font-size: clamp(2.4rem, 8vw, 3rem);
  font-weight: 800; letter-spacing: -.03em;
  color: var(--vm-text); font-variant-numeric: tabular-nums; min-width: 0;
}
.vm-actions { display: flex; flex-direction: column; gap: .55rem; }
.vm-btn {
  display: inline-flex; align-items: center; justify-content: center;
  gap: .5rem; width: 100%;
  height: 52px; padding: 0 1.1rem;
  border: 1px solid transparent; border-radius: 14px;
  font-family: inherit; font-size: .95rem; font-weight: 600;
  letter-spacing: -.005em; white-space: nowrap;
  cursor: pointer;
  transition: background .15s ease, border-color .15s ease, box-shadow .15s ease, transform .1s ease;
}
.vm-btn:active { transform: scale(.98); }
.vm-btn:focus-visible { outline: none; box-shadow: 0 0 0 3px var(--vm-accent-ring); }
.vm-btn svg { flex-shrink: 0; }
.vm-btn--primary { background: var(--vm-accent); color: #fff; box-shadow: 0 4px 14px rgba(37,99,235,.28); }
.vm-btn--primary:hover { background: var(--vm-accent-hover); box-shadow: 0 8px 22px rgba(37,99,235,.34); }
.vm-btn--outline { background: #fff; color: var(--vm-text); border-color: var(--vm-line); }
.vm-btn--outline:hover { border-color: var(--vm-line-strong); background: var(--vm-cell); }
.vm-btn--danger-outline { background: #fff; color: var(--vm-red); border-color: rgba(225,29,46,.35); }
.vm-btn--danger-outline:hover { background: var(--vm-red-dim); border-color: var(--vm-red); }
.vm-empty-state {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: .75rem; padding: 2rem 1rem;
  background: #fff; border: 1.5px dashed var(--vm-line-strong); border-radius: 16px;
  text-align: center; cursor: pointer;
  transition: background .15s ease, border-color .15s ease;
}
.vm-empty-state:hover { border-color: var(--vm-accent); background: var(--vm-accent-dim); }
.vm-empty-state-ico {
  display: grid; place-items: center;
  width: 64px; height: 64px; border-radius: 18px;
  background: var(--vm-accent-dim); color: var(--vm-accent);
  font-size: 1.6rem;
}
.vm-empty-state h3 { margin: 0; font-size: 1rem; font-weight: 700; color: var(--vm-text); }
.vm-empty-state p { margin: 0; font-size: .82rem; color: var(--vm-muted); line-height: 1.5; }

/* ══════ MODAL 3 — ASIGNAR ══════ */
.vm-products {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: .7rem;
}
@media (max-width: 480px) {
  .vm-products { grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: .55rem; }
}
.vm-product {
  display: flex; flex-direction: column;
  background: #fff; border: 1px solid var(--vm-line);
  border-radius: 14px; overflow: hidden;
  cursor: pointer;
  animation: vm-in .22s ease both;
  transition: border-color .14s ease, box-shadow .14s ease, transform .14s ease;
  font-family: inherit; color: inherit; text-align: left;
}
button.vm-product { width: 100%; }
.vm-product:hover { border-color: var(--vm-accent); box-shadow: 0 8px 24px rgba(37,99,235,.14); transform: translateY(-2px); }
.vm-product:active { transform: scale(.98); }
.vm-product-img {
  display: grid; place-items: center;
  aspect-ratio: 1;
  background: var(--vm-cell);
  border-bottom: 1px solid var(--vm-line);
  overflow: hidden;
}
.vm-product-img img { width: 100%; height: 100%; object-fit: cover; }
.vm-product-body { padding: .55rem .65rem .7rem; display: flex; flex-direction: column; gap: 2px; }
.vm-product-name {
  font-size: .82rem; font-weight: 600; color: var(--vm-text);
  line-height: 1.3;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden; min-height: calc(.82rem * 1.3 * 2);
}

@media (prefers-reduced-motion: reduce) {
  .vm-overlay, .vm-panel, .vm-slot, .vm-product, .vm-detail-card { animation: none; }
  .vm-slot, .vm-product, .vm-btn, .vm-counter-btn, .vm-trigger, .vm-empty-state, .vm-search, .vm-head-back, .vm-head-close { transition: none; }
  .vm-slot:hover, .vm-product:hover { transform: none; }
}
`;

if (typeof window !== 'undefined' && !document.getElementById('vm-styles')) {
  const el = document.createElement('style');
  el.id = 'vm-styles'; el.textContent = VM_CSS;
  document.head.appendChild(el);
}

/* ── Iconos ── */
const IcoAbacus = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="18" rx="2" /><line x1="8" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="16" y2="21" /><line x1="2" y1="9" x2="8" y2="9" /><line x1="16" y1="15" x2="22" y2="15" /></svg>;
const IcoBack = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const IcoClose = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
const IcoBan = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
const IcoBox = () => <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8M1 3h22v5H1zM10 12h4" /></svg>;
const IcoSearch = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>;
const IcoSync = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>;
const IcoSwap = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 3 21 3 21 8" /><line x1="4" y1="20" x2="21" y2="3" /><polyline points="21 16 21 21 16 21" /><line x1="15" y1="15" x2="21" y2="21" /></svg>;
const IcoClear = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /><path d="M10 11v6M14 11v6" /></svg>;
const IcoAssign = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" /></svg>;

/* ── Portal helper — renderiza el modal en document.body ── */
function VMPortal({ open, onClose, children, size }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open || typeof document === 'undefined') return null;

  const handleOverlayMouseDown = (e) => {
    if (e.target === overlayRef.current) onClose?.();
  };

  return ReactDOM.createPortal(
    <div className="vm-root">
      <div className="vm-overlay" ref={overlayRef} onMouseDown={handleOverlayMouseDown} role="dialog" aria-modal="true">
        <div className={`vm-panel${size === 'sm' ? ' vm-panel--sm' : ''}`} role="document">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% ORIGINAL
════════════════════════════════════════════════════════ */
function ModalOperator({ machine, token, branchoffice_id }) {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let business = JSON.parse(localStorage.getItem('business_vending'));
  let branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'));

  let positions_Local = [12, 12, 12, 12, 12, 12, 12, 12]
  const [positions, setPositions] = useState([]);
  const [buttonActive, setButtonActive] = useState(false)

  const [showModalStock, setShowModalStock] = useState(false)
  const [disablePosition, setDisablePosition] = useState([])
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [showModalAssign, setShowModalAssign] = useState(false);
  const [showModalKeyboardControl, setShowModalKeyboardControl] = useState(false)
  const [showModalTemp, setShowModalTemp] = useState(false);
  const [allProductsBranchoffice, setAllProductsBranchoffice] = useState([])
  const [productSelect, setProductSelect] = useState({ group: "" });
  const [eventHandlerModalAmount, setEventHandlerModalAmount] = useState(0);
  const [tempConfig, setTempConfig] = useState({ tempOn: 0, tempOff: 0 });
  const [resultPosition, setResultPosition] = useState([]);
  const [temporalItem, setTemporalItem] = useState([]);

  function actualizar() { window.location.reload(); }

  const getPosition_consult = async () => {
    console.log("entre a consuta de informacion ya guardada")
    if (positions_Local.length > 0) {
      try {
        let array_position_vending_scan = positions_Local
        const response = await GroupsFechtAPI.getGroupsByMachine(machine.machine_per_branch_id, token);
        console.log(response);
        let postions_response = response.data.groups
        let temp_position = new Array;
        let temp_position_disables = new Array;
        for (let i = 0; i < array_position_vending_scan.length; i++) {
          for (let f = 0; f < postions_response.length; f++) {
            if ((i + 1) == postions_response[f].positionX) {
              if (postions_response[f].positionY <= array_position_vending_scan[i]) {
                postions_response[f].status_position = true
                temp_position.push(postions_response[f])
              } else if (postions_response[f].positionY > array_position_vending_scan[i]) {
                postions_response[f].status_position = false
                let detail = { "group_id": null, "position_id": postions_response[f].position_id, "amount": 0 }
                temp_position_disables.push(detail)
                temp_position.push(postions_response[f])
              }
            }
          }
        }
        console.log(temp_position)
        setPositions(temp_position.reverse())
        localStorage.setItem('positions', JSON.stringify(array_position_vending_scan))
        cleanDisblePosition(temp_position_disables)
      } catch (err) { console.log(err); }
    } else {
      ErrorAlert("", "Debe escanear las posiciones", "warning")
    }
  }

  const getAllGroupsBranchOffice = async () => {
    try {
      const response = await GroupsFechtAPI.getGroupsByBranchoffice(branchoffice_id, token)
      setAllProductsBranchoffice(response.data.data)
      setTemporalItem(response.data.data)
      console.log(response);
    } catch (err) { console.log(err); }
  }

  const cleanDisblePosition = async (data) => {
    try {
      const response = await PositionFetchAPI.cleanPositionsDisabled(machine.machine_per_branch_id, data, token)
      console.log(response);
    } catch (err) { console.log(err); }
  }

  const assignProductAndUpdate = async (item) => {
    LoadingAlert()
    try {
      const response = await PositionFetchAPI.updatePositionToGroup(machine.machine_per_branch_id, item, token)
      console.log(response);
      getPosition_consult();
      console.log(response);
      setShowModalDetail(false);
      ErrorAlert("", "Producto actualizado", "success")
    } catch (err) { console.log(err); }
  }

  const handleModalDetails = (position) => {
    setProductSelect(position);
    setShowModalDetail(true)
  }

  const handleDecrease = () => {
    if (productSelect.amount > 0) {
      productSelect.amount = (productSelect.amount - 1)
      setProductSelect(productSelect)
      setEventHandlerModalAmount(1);
    }
  }

  const handleIncrease = () => {
    productSelect.amount = (productSelect.amount + 1)
    setProductSelect(productSelect)
    setEventHandlerModalAmount(1);
  }

  const handleupdateProductPosition = (item) => {
    item.position_id = productSelect.position_id;
    console.log(item);
    assignProductAndUpdate(item);
    setShowModalAssign(false);
    setShowModalDetail(false);
  }

  const handleIncreaseTemp = (type) => {
    tempConfig.tempOff = (tempConfig.tempOff + 1);
    tempConfig.tempOn = (tempConfig.tempOff + 4);
    setTempConfig(tempConfig)
    setEventHandlerModalAmount(1)
  }

  const handleDecreaseTemp = (type) => {
    if (tempConfig.tempOff > 0) {
      tempConfig.tempOff = (tempConfig.tempOff - 1);
      tempConfig.tempOn = (tempConfig.tempOff + 4);
    }
    setTempConfig(tempConfig)
    setEventHandlerModalAmount(1)
  }

  const clearPosition = () => {
    let data = {
      "tax": null, "taxtValue": null, "dTasaITBMSValue": null,
      "group_id": null, "branchoffice_id": null, "price": null,
      "name": null, "img": null, "status": null, "description": null,
      "amount": null, "group_type": null, "position_id": productSelect.position_id
    }
    handleupdateProductPosition(data)
  }

  const reload = () => { window.location.reload() }

  const dispense = async (X, Y) => {
    LoadingAlert("Despacho de prueba", "Espere un momento por favor...")
    let json = { funcion: "DESPACHAR", datos: [{ X: X.toString(), Y: Y.toString() }] }
    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token)
      const response = await VendingFetchAPI.operation(response_machine.data.data.android_ip, json)
      let status = response.data.data
      if (status == 0) { ErrorAlert("", "Despacho exitoso", "success") }
      else { ErrorAlert("", "Error de despacho", "error") }
    } catch (err) { ErrorAlert("", "Error de comunicacion", "error"); console.log(err); }
  }

  const viewPosition = () => {
    const reversedArray = positions
    const listPosition = reversedArray.map((position, i) => {
      const coord = `${position.positionX}·${position.positionY}`;

      // Inhabilitado
      if (position.status_position != true) {
        return (
          <div className="vm-slot is-disabled" key={i} aria-label={`Posición ${coord} inhabilitada`}>
            <span className="vm-slot-coord-abs">{coord}</span>
            <span className="vm-slot-disabled-ico"><IcoBan /></span>
            <span className="vm-slot-disabled-lbl">Inhabilitado</span>
          </div>
        );
      }

      // Vacío
      if (position.group_id == null) {
        return (
          <button
            type="button"
            className="vm-slot is-empty"
            key={i}
            onClick={() => handleModalDetails(position)}
            aria-label={`Posición ${coord} vacía, tocar para asignar producto`}
          >
            <span className="vm-slot-coord-abs">{coord}</span>
            <span className="vm-slot-plus">+</span>
            <span className="vm-slot-empty-lbl">Asignar producto</span>
          </button>
        );
      }

      // Con producto
      const state = position.amount == 0 ? 'is-out' : position.amount > 3 ? 'is-ok' : 'is-low';
      const tag = position.amount == 0 ? 'Sin stock' : position.amount > 3 ? 'Disponible' : 'Stock bajo';

      return (
        <button
          type="button"
          className={`vm-slot ${state}`}
          key={i}
          onClick={() => handleModalDetails(position)}
          aria-label={`Posición ${coord}, ${position.name}, ${position.amount} unidades, ${tag}`}
        >
          <div className="vm-slot-head">
            <span className="vm-slot-dot" />
            <span className="vm-slot-coord">{coord}</span>
            <span className="vm-slot-chip">{tag}</span>
          </div>
          <span className="vm-slot-name" title={position.name}>{position.name}</span>
          <div className="vm-slot-foot">
            <span className="vm-slot-amount">{position.amount}</span>
            <span className="vm-slot-unit">und</span>
          </div>
        </button>
      );
    });
    return listPosition;
  }

  const handlerFilter = (e) => {
    if (e.target.value == "") {
      setTemporalItem(allProductsBranchoffice)
    } else {
      let arrayFilter = []
      allProductsBranchoffice.forEach(item => {
        let valueCondition = item.name.toLowerCase().includes(e.target.value.toLowerCase())
        if (valueCondition == true) { arrayFilter.push(item) }
      });
      setTemporalItem(arrayFilter)
    }
  }

  const viewProductBranchoffice = () => {
    if (!temporalItem.length) {
      return (
        <div className="vm-empty">
          <IcoBox />
          <p>No hay productos que coincidan con tu búsqueda.</p>
        </div>
      );
    }
    const listProducts = temporalItem.map((item) => (
      <button
        type="button"
        className="vm-product"
        key={item.group_id}
        onClick={() => handleupdateProductPosition(item)}
      >
        <div className="vm-product-img">
          <img
            src={item.img
              ? buildCloudinaryImageUrl({ url: item.img, width: 300, quality: "auto", type: "image" })
              : defaultImage}
            alt={item.name}
          />
        </div>
        <div className="vm-product-body">
          <span className="vm-product-name">{item.name}</span>
        </div>
      </button>
    ));
    return listProducts;
  }

  useEffect(() => { setEventHandlerModalAmount(0); }, [eventHandlerModalAmount]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  const currentCoord = productSelect?.positionX ? `${productSelect.positionX}·${productSelect.positionY}` : '';

  return (
    <>
      {/* ── TRIGGER — abre modal 1 y consulta las posiciones (lógica intacta) ── */}
      <button
        type="button"
        className="vm-trigger btn btn-outline-primary btn-sm border-0"
        onClick={() => (setShowModalStock(true), getPosition_consult())}
        title="Área de abastecimiento"
      >
        <IcoAbacus />
      </button>

      {/* ══════════════════════════════════════════
          MODAL 1 — STOCK / ÁREA DE ABASTECIMIENTO
      ══════════════════════════════════════════ */}
      <VMPortal open={showModalStock} onClose={() => setShowModalStock(false)}>
        <header className="vm-head">
          <button type="button" className="vm-head-back" onClick={() => setShowModalStock(false)} aria-label="Volver">
            <IcoBack />
          </button>
          <div className="vm-head-title">
            <h2 className="vm-head-h">Área de abastecimiento</h2>
            <span className="vm-head-count" aria-label={`${positions.length} posiciones`}>{positions.length}</span>
          </div>
          <button type="button" className="vm-head-close" onClick={() => setShowModalStock(false)} aria-label="Cerrar">
            <IcoClose />
          </button>
        </header>

        <div className="vm-body">
          <div className="vm-legend" aria-hidden="true">
            <span className="vm-legend-item"><span className="vm-legend-dot is-ok" /> Disponible</span>
            <span className="vm-legend-item"><span className="vm-legend-dot is-low" /> Stock bajo</span>
            <span className="vm-legend-item"><span className="vm-legend-dot is-out" /> Sin stock</span>
            <span className="vm-legend-item"><span className="vm-legend-dot is-empty" /> Vacío</span>
            <span className="vm-legend-item"><span className="vm-legend-dot is-disabled" /> Inhabilitado</span>
          </div>

          {positions.length > 0 ? (
            <div className="vm-grid stock-container modalOperator">
              {viewPosition()}
            </div>
          ) : (
            <div className="vm-empty">
              <IcoBox />
              <p>No hay posiciones escaneadas todavía.</p>
            </div>
          )}
        </div>
      </VMPortal>

      {/* ══════════════════════════════════════════
          MODAL 2 — DETALLE POSICIÓN
      ══════════════════════════════════════════ */}
      <VMPortal open={showModalDetail} onClose={() => setShowModalDetail(false)} size="sm">
        <header className="vm-head top-menu-vending">
          <button type="button" className="vm-head-back btn-menu-vending" onClick={() => setShowModalDetail(false)} aria-label="Volver">
            <IcoBack />
          </button>
          <div className="vm-head-title menu-vending-title">
            <h2 className="vm-head-h">En abastecimiento</h2>
            {currentCoord && <span className="vm-head-sub">· {currentCoord}</span>}
          </div>
          <button type="button" className="vm-head-close" onClick={() => setShowModalDetail(false)} aria-label="Cerrar">
            <IcoClose />
          </button>
        </header>

        <div className="vm-detail">
          {/* ── Producto asignado ── */}
          <RenderIf isTrue={productSelect.group_id != null}>
            <div className="vm-detail-card">
              {currentCoord && <span className="vm-detail-coord">Posición {currentCoord}</span>}
              <div className="vm-detail-img">
                <img
                  src={productSelect.img
                    ? buildCloudinaryImageUrl({ url: productSelect.img, width: 400, quality: "auto", type: "image" })
                    : defaultImage}
                  alt={productSelect.name}
                />
              </div>
              <h2 className="vm-detail-title modal-title-product">{productSelect.name}</h2>
            </div>

            <div className="vm-counter">
              <div className="vm-counter-label">Cantidad de cargas realizadas</div>
              <div className="vm-counter-row">
                {/* handleDecrease — lógica original intacta */}
                <button type="button" className="vm-counter-btn is-minus round-button" onClick={() => handleDecrease()} aria-label="Restar">
                  <span className="minus">−</span>
                </button>
                <span className="vm-counter-num">{productSelect.amount}</span>
                {/* handleIncrease — lógica original intacta */}
                <button type="button" className="vm-counter-btn round-button" onClick={() => handleIncrease()} aria-label="Sumar">
                  <span className="plus">+</span>
                </button>
              </div>
            </div>

            <div className="vm-actions">
              {/* assignProductAndUpdate — lógica original intacta */}
              <button type="button" className="vm-btn vm-btn--primary btn btn-primary btn-vending-product btn-menu-vending"
                onClick={() => assignProductAndUpdate(productSelect)}>
                <IcoSync /> Actualizar stock
              </button>

              <RenderIf isTrue={productSelect.group_id != null}>
                {/* setShowModalAssign + getAllGroupsBranchOffice — lógica original intacta */}
                <button type="button" className="vm-btn vm-btn--outline btn btn-primary btn-vending-product"
                  onClick={() => (setShowModalAssign(true), getAllGroupsBranchOffice())}>
                  <IcoSwap /> Cambiar producto
                </button>
                {/* clearPosition — lógica original intacta */}
                <button type="button" className="vm-btn vm-btn--danger-outline btn btn-success btn-vending-product"
                  onClick={() => clearPosition()}>
                  <IcoClear /> Limpiar posición
                </button>
              </RenderIf>
            </div>
          </RenderIf>

          {/* ── Posición vacía ── */}
          <RenderIf isTrue={productSelect.group_id == null}>
            {currentCoord && <span className="vm-detail-coord" style={{ alignSelf: 'center' }}>Posición {currentCoord}</span>}
            <div className="vm-empty-state empty-stock text-center bg-light"
              onClick={() => (setShowModalAssign(true), getAllGroupsBranchOffice())}>
              <span className="vm-empty-state-ico">
                <i className="uil uil-bring-bottom" />
              </span>
              <h3>Posición vacía</h3>
              <p className="text-muted">
                No hay ningún producto asignado.<br />
                Toca aquí para asignar uno.
              </p>
            </div>
            <div className="vm-actions">
              <button type="button" className="vm-btn vm-btn--primary btn btn-primary btn-vending-product btn-menu-vending"
                onClick={() => (setShowModalAssign(true), getAllGroupsBranchOffice())}>
                <IcoAssign /> Asignar producto
              </button>
            </div>
          </RenderIf>
        </div>
      </VMPortal>

      {/* ══════════════════════════════════════════
          MODAL 3 — ASIGNAR PRODUCTO
      ══════════════════════════════════════════ */}
      <VMPortal open={showModalAssign} onClose={() => setShowModalAssign(false)}>
        <header className="vm-head vm-head--assign">
          <div className="vm-head-row">
            <button type="button" className="vm-head-back" onClick={() => setShowModalAssign(false)} aria-label="Volver">
              <IcoBack />
            </button>
            <div className="vm-head-title">
              <h2 className="vm-head-h">Asignar producto</h2>
              {currentCoord && <span className="vm-head-sub">· {currentCoord}</span>}
            </div>
            <button type="button" className="vm-head-close" onClick={() => setShowModalAssign(false)} aria-label="Cerrar">
              <IcoClose />
            </button>
          </div>
          <label className="vm-search">
            <span className="vm-search-ico"><IcoSearch /></span>
            <input
              type="text"
              className="vm-search-input input-vending-filter"
              placeholder="Buscar producto…"
              onChange={(e) => handlerFilter(e)}
              autoFocus
            />
          </label>
        </header>

        <div className="vm-body">
          <div className="vm-products">
            {viewProductBranchoffice()}
          </div>
        </div>
      </VMPortal>

      {/* imports no-JSX preservados */}
      {void [Button, Modal, Row, Col, RequestLocalFetchAPI, empty, stand, Swal, business, branchoffice,
        buttonActive, disablePosition, showModalKeyboardControl, showModalTemp,
        tempConfig, resultPosition, handleIncreaseTemp, handleDecreaseTemp, actualizar, reload, dispense]}
    </>
  )
}

export default ModalOperator